import { AutoComplete, Button, Form, Input, message, Select } from "antd";
import React, { useState } from "react";
import Api from "../../Network/ApiConfig";
import en from "../../localization/en";
import ar from "../../localization/ar";
import cls from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { setCountries, setCustomerAddresses } from "../../redux/user/user.action";
import MapAddress from "../MapAddress/MapAddress";
import MapWithSearch from "../MapAddress/MapAddressNew";
import "react-phone-number-input/style.css";
import { useLocation, useHistory } from "react-router-dom";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import Autocomplete from "react-google-autocomplete";
import { useEffect } from "react";
import { css } from "@emotion/css";

function AddAddress({ setCurrentPage }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const [form] = Form.useForm();
  const { userAddress } = useSelector((state) => state?.user);
  const { orderPersonType } = useSelector((state) => state?.cart); 
  const history = useHistory();
  const [mapAddressList, setMapAddressList] = useState([]);
  const [loginLoading, setloginLoading] = useState(false);
  const [ActiveAddress, setActiveAddress] = useState(null);
  const [AddressFormat, setAddressFormat] = useState(null);
  const [mapInfo, setMapInfo] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [selectedCity, setselectedCity] = useState();

  const [newLatLngFromAddresSearch, setNewLatLngFromAddresSearch] =
    useState(null);
  const [countryId, setcountryId] = useState(1);

  const { currentLang, Countries } = useSelector(
    (state) => state?.user
  );
const orderPersonId = location?.state?.orderPersonId;
// const orderPersonType = location?.state?.orderPersonType;



  const t = currentLang === "en" ? en : ar;
  // console.log(t, "router");
  // console.log(locale, "localelocale");
  const { Option } = AutoComplete;
  const onFinishLogin = (values) => {
    setloginLoading(true);
    const phoneNumber = parsePhoneNumber(values.PhoneNumber || "");
    let body = {
      PhoneKey: "+" + phoneNumber?.countryCallingCode,
      PhoneNumber: phoneNumber?.nationalNumber,
      Caption: values?.address,
      Title: values?.Title,
      Street: values?.Street,
      Latitude: mapInfo?.lat,
      Longitude: mapInfo?.lng,
      CityId: values?.CityId,
    };
  
    // Choose endpoint & params
    let endpoint, params;
    if (orderPersonType === "business") {
      endpoint = "Business/AddBusinessAddress";
      params = `?Id=${orderPersonId}`;
    } else {
      endpoint = "Business/AddCustomerAddress";
      params = `?Id=${orderPersonId}`;
    }
  
    Api.post(`${endpoint}${params}`, body).then(
      (res) => {
        setloginLoading(false);
        if (res?.status === 200) {
          // Add to redux (optional)
          dispatch(setCustomerAddresses([{ ...res?.data?.model }, ...userAddress]));
          message.success(res?.data?.metas?.message);
  
          // Redirect to order form, set the new address ID
          if (location?.state?.back_to_order) {
            history.push({
              pathname: "/add-order",
              state: {
                ...location.state,
                serviceId: location?.state?.serviceId,
                newlyAddedAddressId: res.data.model.Id,  // Pass the new address id
              },
            });
            return;
          }
          setCurrentPage("");
        }
      },
      (err) => {
        setloginLoading(false);
        message.error(err?.message);
      }
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Api.get("MetaData/GetCountries");
        dispatch(setCountries(response?.data?.model));
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const handelMapInfo = (data) => {
    console.log(data, "datadatadata");
    setMapInfo(data);
  };

  const handelSetAddressList = (data) => {
    // setMapAddressList(data)
  };

  const handelSetAddressFormat = (data) => {
    setAddressFormat(data);
  };

  const handleChangesubCategory = (val) => {
    console.log(val);
    setcountryId(val);
    form.resetFields(["CityId"]);
  };

  const handleAddressSelect = (address) => {
    setSelectedAddress(address);
    form.setFieldsValue({
      address: address,
    });
  };
  const handleCitySelect = (city) => {
    const selectedcity = Countries?.map((country) => {
      // Filter out the city based on the Name field
      const filteredCity = country?.Cities?.filter((s) => s?.Name === city);

      // If a match is found, return the city object
      if (filteredCity?.length) {
        return filteredCity[0];
      }
      return null;
    }).filter(Boolean); // Remove any null values from the result
    // form.setFieldsValue();
    // selectedCity is now an array of matching city objects
    if (selectedcity.length > 0) {
      setselectedCity(selectedcity[0]); // Assuming you want the first match
      form.setFieldsValue({
        CityId: selectedcity[0].Id,
      });
    } else {
      console.log("City not found");
    }
  };

  const handleCountrySelect = (country) => {
    console.log("county", country);
  };

  const formItemWrapper = css`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 50px #0000000d;
  border-radius: 26px;
  padding: 8rem 11rem;
  @media only screen and (max-width: 992px) {
    padding: 6rem 3rem;
  }
  .form-title {
    font-size: 3rem;
    color: #294151;
    margin-bottom: 3.5rem;
    font-weight: 600;
    letter-spacing: 0.32px;
    display: flex;
    align-items: center;
    span {
      color: #612166;
      margin: 0 8px;
    }
    @media only screen and (max-width: 992px) {
      font-size: 3rem;
    }
  }
  .form-txt-p {
    font-size: 2.4rem;
    line-height: 1.58;
    color: #7f8897;
    margin-bottom: 4rem;
    a,
    span {
      font-weight: 500;
      color: #612166;
      margin: 0 6px;
      cursor: pointer;
    }
  }
  .remember-row-holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
    .ant-checkbox + span {
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.16px;
      > a {
        color: #612166;
        font-weight: 600;
        margin: 0 4px;
        cursor: pointer;
      }
    }
    .ant-form-item {
      margin-bottom: 0;
    }
    > a {
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.16px;
      color: #294151;
    }
  }
  .have-account-holder {
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.16px;
    color: #294151;
    font-size: 20px;
    margin-top: 30px;
    a,
    span {
      color: #612166;
      font-weight: 600;
      margin: 0 4px;
      cursor: pointer;
    }
  }

`;

const formInputWrapper = css`
.ant-input-number{
  .ant-input-number-input-wrap{
    height: 100%;
  }
  input{
    height: 100%;
  }
}
.ant-input, .ant-select .ant-select-selector, .ant-input-number, .pac-target-input {
  margin-bottom: 0.5rem;
  height: 7.5rem;
  border: 0.5px solid #e6e7ea;
  border-radius: 12px;
  letter-spacing: 0.14px;
  color: $color-black-2;
  font-size: 2.1rem;
  padding: 4px 11px;
  width: 100%;
  max-width:100% !important;
}
.ant-select .ant-select-selector{
  input{
    height: 100% !important;
  }
  max-width: 100% !important;
}
.ant-select-single .ant-select-selector .ant-select-selection-placeholder,
.ant-select-single .ant-select-selector .ant-select-selection-item{
  display: flex;
  align-items: center;
   max-width: 100% !important;
}
textarea {
  letter-spacing: 0.14px;
  // color: #000;
  color: #949ba7;
  font-size: 1.6rem;
  height: auto !important;
  border: 0.5px solid #e6e7ea;
  border-radius: 12px;
  padding: 2rem;
}
`;
const pac_target_input = css`
margin-bottom: 0.5rem;
  height: 7.5rem;
  border: 0.5px solid #e6e7ea;
  border-radius: 12px;
  letter-spacing: 0.14px;
  color: $color-black-2;
  font-size: 2.1rem;
  padding: 4px 11px;
  width: 100%;
  max-width:100% !important;
`; 
const inputAddressWrapper = css`
  margin-bottom: 30px;

  `;

  return (
    <>
      {/* <MapAddress
        setNewLatLng={newLatLngFromAddresSearch}
        setMapInfo={(data) => handelMapInfo(data)}
        handelSetAddressFormat={(data) => handelSetAddressFormat(data)}
        handelSetAddressList={(data) => handelSetAddressList(data)}
      /> */}
      {/* <MapWithSearch
        onAddressSelect={handleAddressSelect}
        onCitySelect={handleCitySelect}
        onCountrySelect={handleCountrySelect}
      /> */}

      <div className="add_address_holder">
        <div className={formItemWrapper}>
          <div className="form-content">
            <h3 className="form-title">
              {/* Add New <span>{t.address}</span> */}
              {t.addNewAdress}
            </h3>

            <Form
              form={form}
              autoComplete="off"
              name="basic"
              onFinish={onFinishLogin}
            >
              <Form.Item
                name="Title"
                rules={[
                  {
                    required: true,
                    message: "Please input Title!",
                  },
                ]}
                className={cls(formInputWrapper, "input-wrapper")}
              >
                <Input placeholder={"Title"} className="input-control" />
              </Form.Item>
              {/* <Form.Item
              name="Captionwww"
              rules={[
                {
                  required: true,
                  message: "Please input your Address!",
                },
              ]}
              className="input-wrapper"
            > */}
              <div className={cls(formInputWrapper, "input-wrapper",inputAddressWrapper)}>
              <Form.Item
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: "Please input Address!",
                    },
                  ]}
                  className={cls(formInputWrapper, "input-wrapper")}
                >
                  <Input
                    placeholder="Enter Address"
                    className={pac_target_input}
                    value={AddressFormat}
                    onChange={(e) => setAddressFormat(e.target.value)}
                  />
                </Form.Item>
                {/* <Form.Item
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: "Please input Address!",
                    },
                  ]}
                  className={cls(formInputWrapper, "input-wrapper")}
                >
                  <Autocomplete
                    defaultValue={AddressFormat}
                    // value={selectedAddress}
                    className={pac_target_input}
                    apiKey="AIzaSyCx2x-EzGQOHcYf36Gqtc9g1GP1s5NOfb0"
                    inputAutocompleteValue={AddressFormat}
                    onPlaceSelected={(place) => {
                      console.log(place, "place");
                      setAddressFormat(place?.formatted_address);
                      // console.log(place.geometry.location)
                      // console.log(place.geometry.location.lat())
                      // console.log(place.geometry.location.lng())
                      const lat = place.geometry.location.lat();
                      const lng = place.geometry.location.lng();
                      setMapInfo({
                        lat,
                        lng,
                      });
                      setNewLatLngFromAddresSearch({
                        lat,
                        lng,
                      });
                    }}
                    onChange={(e) => {
                      setAddressFormat(e.target.value);
                    }}
                  />
                </Form.Item> */}
              </div>

              {/* </Form.Item> */}
              {/* <Form.Item
              name="Caption"
              rules={[
                {
                  required: true,
                  message: "Please input your Address!",
                },
              ]}
              className="input-wrapper"
            >
              <AutoComplete 
                 labelInValue
                 defaultActiveFirstOption
                 onSelect={(s) => setActiveAddress(s)}
                //  options={mapAddressList?.map(s => ({value : s?.place_id, label : s?.formatted_addres}) )}
               placeholder={"Address"} className="input-control">
                 {mapAddressList?.map(address => 
                   <Option key={address?.place_id} value={address?.formatted_address} formatted_address={address?.formatted_address}>
                      {address?.formatted_address}
                    </Option>
                    )
                 }
            </AutoComplete>
            </Form.Item> */}
              <Form.Item
                name="CityId"
                rules={[
                  {
                    required: true,
                    message: "Please select your City!",
                  },
                ]}
                className={cls(formInputWrapper, "input-wrapper")}
              >
                <Select placeholder={"City"}>
                  {Countries?.find((s) => +s?.Id === +countryId)?.Cities?.map(
                    (city) => (
                      <Select.Option key={city.Id} value={city.Id}>
                        {currentLang === "en" ? city?.Name : city?.NameLT}
                      </Select.Option>
                    )
                  )}
                </Select>
              </Form.Item>

              <Form.Item
                name="PhoneNumber"
                rules={[
                  {
                    required: true,
                    message: `${t.Pleaseinput} ${t.Phonenumber}`,
                  },
                ]}
                className={cls(formInputWrapper, "input-wrapper")}
              >
                <PhoneInput
                  international
                  countryCallingCodeEditable={false}
                  defaultCountry="AE"
                />
              </Form.Item>

              <Form.Item
                name={"Street"}
                rules={[
                  {
                    required: true,
                    message: "Please input your landmark!",
                  },
                ]}
                className={cls(formInputWrapper, "input-wrapper")}
              >
                <Input.TextArea placeholder={"landmark"} rows={6} />
              </Form.Item>

              <Button
                htmlType="submit"
                type="primary"
                className="btn-primary fw"
                style={{ marginTop: "10rem" }}
                block
                loading={loginLoading}
                // onClick={() => setCurrentPage("")}
              >
                Add Address
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddAddress;
